module.exports = __webpack_public_path__ + "12287ac0ba364e3f3d500c1fa4c54dbf.pdf";